import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API, saveAuthTokens } from '../App';

export default function MagicLinkCallback() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const token = searchParams.get('token');
    if (token) {
      verifyMagicLink(token);
    } else {
      navigate('/login');
    }
  }, []);

  const verifyMagicLink = async (token) => {
    try {
      const res = await API.post('/api/auth/magic-link/verify', { token });
      saveAuthTokens(res.data);
      window.location.href = '/dashboard';
    } catch (err) {
      setError(err.response?.data?.detail || 'This link is invalid or has expired.');
    }
  };

  if (error) {
    return (
      <div className="min-h-screen bg-[#0F0F0F] flex items-center justify-center">
        <div className="text-center max-w-sm px-4">
          <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-[#A61E17]/20 flex items-center justify-center">
            <span className="text-[#A61E17] text-xl">!</span>
          </div>
          <h2 className="text-lg font-bold text-[#F5F1E8] mb-2">Link expired</h2>
          <p className="text-sm text-[#A0A0A0] mb-4">{error}</p>
          <button onClick={() => navigate('/login')}
            className="px-6 py-2 bg-[#FF4D00] text-[#0A0A0A] font-bold text-sm rounded hover:bg-[#E63E00]">
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#0F0F0F] flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-[#00D4FF] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#A0A0A0] text-sm font-mono">Signing you in...</p>
      </div>
    </div>
  );
}
